import React from 'react';
import { Outlet } from 'react-router-dom';
import { ContextualPaywallModalActivity } from '@melio/subscriptions-ui';

import { AppLayout } from '@/cl/layouts/app-layout/appLayout.component';

export const OnlyFooterLayout = () => {
  return (
    <AppLayout>
      <Outlet />
      <ContextualPaywallModalActivity />
    </AppLayout>
  );
};
